export enum TextType {
    Body,
    About,
    Transcript,
}